import { Link, useLocation } from 'react-router-dom';

const tabs = [
  { to: '/', label: 'Browse', icon: BrowseIcon },
  { to: '/wanted', label: 'Wanted', icon: WantedIcon },
  { to: '/create', label: 'Create', icon: CreateIcon },
  { to: '/me/lots', label: 'My deals', icon: LotsIcon },
  { to: '/me/offers', label: 'Offers', icon: OffersIcon },
] as const;

export function BottomNav() {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-surface/95 backdrop-blur-md border-t border-border safe-bottom">
        <div className="mx-auto max-w-lg flex items-center justify-around h-16 py-1">
        {tabs.map((tab) => {
          const active =
            tab.to === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(tab.to);
          const Icon = tab.icon;
          const isCreate = tab.to === '/create';

          return (
            <Link
              key={tab.to}
              to={tab.to}
              aria-current={active ? 'page' : undefined}
              aria-label={tab.label}
              className={`flex flex-col items-center justify-center gap-0.5 w-16 min-h-[44px] h-full no-underline transition-colors ${
                isCreate
                  ? 'text-cherry-500'
                  : active
                    ? 'text-cherry-500'
                    : 'text-text-muted hover:text-text-secondary'
              }`}
            >
              <Icon
                active={active}
                isCreate={isCreate}
              />
              <span className={`text-[0.625rem] leading-none font-medium ${
                active ? 'text-cherry-500' : ''
              }`}>
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

function BrowseIcon({ active }: { active: boolean; isCreate?: boolean }) {
  return (
    <svg className="w-5 h-5" fill={active ? 'currentColor' : 'none'} viewBox="0 0 24 24" stroke="currentColor" strokeWidth={active ? 0 : 1.75}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z" />
    </svg>
  );
}

function WantedIcon({ active }: { active: boolean; isCreate?: boolean }) {
  return (
    <svg className="w-5 h-5" fill={active ? 'currentColor' : 'none'} viewBox="0 0 24 24" stroke="currentColor" strokeWidth={active ? 0 : 1.75}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3zM6 6h.008v.008H6V6z" />
    </svg>
  );
}

function CreateIcon({ isCreate }: { active: boolean; isCreate?: boolean }) {
  return (
    <div className={`w-9 h-9 rounded-full flex items-center justify-center -mt-3 shadow-lg ${
      isCreate ? 'bg-cherry-500 text-white' : 'bg-cherry-500 text-white'
    }`}>
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
      </svg>
    </div>
  );
}

function LotsIcon({ active }: { active: boolean; isCreate?: boolean }) {
  return (
    <svg className="w-5 h-5" fill={active ? 'currentColor' : 'none'} viewBox="0 0 24 24" stroke="currentColor" strokeWidth={active ? 0 : 1.75}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
    </svg>
  );
}

function OffersIcon({ active }: { active: boolean; isCreate?: boolean }) {
  return (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={active ? 2.25 : 1.75}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
    </svg>
  );
}
